export default __webpack_public_path__ + "static/media/google.1e6a3348.png";